import useLinks from './useLinks'

export default useLinks
